import React, { useMemo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../symphony';

import { AISolutions } from '../../private/components/AISolutions/AISolutions';
import {
	SlAISolutionsContext,
	SolutionContext,
	SolutionType,
} from '../../private/global-constants';
import {
	IAnswerExplanationData,
	IQuestionData,
	ISolution,
} from '../../private/global-interface';
import { SlActionsSolutionsService } from '../../private/services/ActionsService/sl-actions-solutions.service';
import { KodieContext } from '../../private/services/context';
import { useComponentWillMount } from '../../../shared/public/SlUtils/useComponentWillMount';

import s from './SlAISolutions.scss';
import { IMaterialHeader, MaterialType } from '../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ICode } from '../../../api/public/code-assistant';

export { SolutionType, SolutionContext };

export interface ISlAISolutionsProps {
	solutionsData: {
		materialType: MaterialType;
		materialHeader?: IMaterialHeader;
		codes?: ICode[];
		problem?: string;
		session?: string;
		solution?: ISolution;
		questionData?: IQuestionData;
		answerExplanationData?: IAnswerExplanationData;
		lessonContent?: string;
		coursename?: string;
		solutionContext?: SolutionContext;
	};
	className?: string;
	OpenButton?: React.ComponentType<{ onClick: () => void }>;
	solutionType?: SolutionType;
	isTIYWidget?: boolean;
	isLightMode?: boolean;
}

export function SlAISolutions({
	solutionsData,
	className,
	OpenButton,
	solutionType = SolutionType.SidePanel,
	isTIYWidget,
	isLightMode,
}: ISlAISolutionsProps) {
	useStyles(s);
	useComponentWillMount(() => {
		Container.take(SlAISolutionsContext, SlActionsSolutionsService);
	});

	const contextData = useMemo(
		() => ({
			context: solutionsData.solutionContext || SolutionContext.Practice,
		}),
		[solutionsData.solutionContext],
	);

	return (
		<KodieContext.Provider value={contextData}>
			<AISolutions
				isTIYWidget={isTIYWidget}
				isLightMode={isLightMode}
				OpenButton={OpenButton}
				solutionsData={solutionsData}
				className={className}
				solutionType={solutionType}
			/>
		</KodieContext.Provider>
	);
}
